var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceUnverified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27539 2.15421C7.74139 1.97315 8.25863 1.97307 8.72461 2.15421L12.3779 3.5751C12.8969 3.77706 13.2391 4.27698 13.2393 4.83389V6.20401C13.2393 9.19949 11.6479 11.97 9.06055 13.4794C8.40521 13.8615 7.59482 13.8614 6.93945 13.4794C4.35193 11.97 2.76074 9.1996 2.76074 6.20401V4.83389C2.76089 4.27689 3.10292 3.777 3.62207 3.5751L7.27539 2.15421ZM9.82617 6.17374C9.59457 5.94218 9.21987 5.94217 8.98828 6.17374L8 7.16202L7.01172 6.17374C6.78013 5.94214 6.40544 5.94217 6.17383 6.17374C5.94224 6.40535 5.94223 6.78003 6.17383 7.01163L7.16211 7.99991L6.17383 8.98819C5.94224 9.21978 5.94227 9.59447 6.17383 9.82608C6.40544 10.0576 6.78013 10.0577 7.01172 9.82608L8 8.8378L8.98828 9.82608C9.21988 10.0577 9.59457 10.0577 9.82617 9.82608C10.0577 9.59448 10.0577 9.21978 9.82617 8.98819L8.83789 7.99991L9.82617 7.01163C10.0577 6.78004 10.0577 6.40534 9.82617 6.17374Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceUnverified);
export default __webpack_public_path__ + "static/media/Insurance_unverified.9690d81371c9494ad55ba6c3846a895f.svg";
export { ForwardRef as ReactComponent };